import styled from 'styled-components';

export const InfoCard = styled.div`
  width: 100%;
  background-color: #53596240;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
`;

export const InfoText = styled.p`
  color: #b4bbc3;
  text-align: center;
  font-size: 12px;
  margin-bottom: 20px;
  line-height: 1.5;
`;

export const InviteButton = styled.button`
  background-color: #c4f538;
  border: none;
  border-radius: 12px;
  padding: 14px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #000000;
  margin-top: 8px;
`;

export const LeaderBoardWrapper = styled.div`
  margin-top: 14px;
`;

export const Label = styled.p`
  font-size: 14px;
  font-family: Public-Sans, sans-serif;
  color: #dde4ee;
  font-weight: 600;
`;

export const PlayerRowItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  gap: 12px;
  border-radius: 12px;
  background: #212730;
`;

export const MedalWrapper = styled.div`
  position: relative;
`;

export const BonusAmount = styled.div`
  text-align: center;
  font-family: Public-Sans, sans-serif;
  font-size: 14px;
  font-weight: 600;
`;

export const GamerName = styled.p`
  text-overflow: ellipsis;
  font-family: Public-Sans, sans-serif;
  font-size: 14px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 150px;
`;

export const MedalPosition = styled.p`
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  font-family: Public-Sans, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 12px;
  color: rgba(0, 0, 0, 0.8);
  text-align: center;
`;

export const NoReferralsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
`;
export const NoReferralsTitle = styled.p`
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
`;
export const NoReferralsDescription = styled.p`
  color: #7a7e85;
  text-align: center;
  font-size: 12px;
  margin-bottom: 20px;
`;
